import { desktopMin } from '@css/constants'

export const useDesktop = (): boolean => typeof window !== 'undefined'
  ? window.matchMedia(`(min-width: ${desktopMin})`).matches
  : true
